import { createSimpleContext } from "@opencode-ai/ui/context"

export type FilePathLink = {
  directory: string
  onFocus: (path: string) => void
  // 同步存在性判断：用于决定裸文件名行内代码是否包成可点击链接。
  // 返回 true=确认存在于工作目录 → 包链接；false/undefined=不存在或未知 → 不包。
  exists?: (path: string) => boolean | undefined
}

export const { use: useFilePathLink, provider: FilePathLinkProvider } = createSimpleContext({
  name: "FilePathLink",
  init: (props: FilePathLink) => ({
    get directory() {
      return props.directory
    },
    onFocus: props.onFocus,
    exists: props.exists,
  }),
})
